import { Stack } from '../../../../Layout/Stack';
import { Text } from '../../../../Typography/Text/Text';
import { ChooseDonationDurationButtons } from '../../buttons/ChooseDonationDurationButtons/ChooseDonationDurationButtons';

type RecurringDonationProps = {
  title?: string;
  onChange: (value: boolean) => void;
  defaultValue?: boolean;
  value?: boolean;
  formKey?: string;
};

const RecurringDonationForm = ({
  title = 'Donation Duration',
  formKey,
  ...rest
}: RecurringDonationProps) => {
  return (
    <Stack>
      <Text fz={{ base: 'sm', sm: 'md' }} fw={600} c="gray.8">
        {title}
      </Text>
      <ChooseDonationDurationButtons {...rest} formKey={formKey} />
    </Stack>
  );
};

export { RecurringDonationForm };
